import { pgTable, uuid, integer, timestamp, primaryKey, index } from "drizzle-orm/pg-core";
import { products } from "./products.js";

// Manual per-product recommendation picks (Sept 9 report #11, miluliem
// pattern). similar_products = cross-sell alternatives shown on the PDP;
// associated_products = buy-together picks shown in cart/checkout upsell.
// One-directional: adding B to A's list inserts only (A, B).

export const similarProducts = pgTable(
  "similar_products",
  {
    productId: uuid("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    similarProductId: uuid("similar_product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    sortOrder: integer("sort_order").notNull().default(0),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    pk: primaryKey({ columns: [t.productId, t.similarProductId] }),
    productIdx: index("similar_products_product_idx").on(t.productId),
  })
);

export const associatedProducts = pgTable(
  "associated_products",
  {
    productId: uuid("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    associatedProductId: uuid("associated_product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    sortOrder: integer("sort_order").notNull().default(0),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    pk: primaryKey({ columns: [t.productId, t.associatedProductId] }),
    productIdx: index("associated_products_product_idx").on(t.productId),
  })
);

export type SimilarProduct = typeof similarProducts.$inferSelect;
export type AssociatedProduct = typeof associatedProducts.$inferSelect;
